import { Spin, Table, Typography } from "antd";
import { UpCircleFilled, DownCircleFilled, CloseCircleFilled } from "@ant-design/icons";

const StopsTable = ({ addedStops, handleUpdateStops, isLoading }) => {
  const columns = [
    {
      title: "Address",
      dataIndex: "text",
      key: "text",
      render: (text) => <Typography.Text>{text}</Typography.Text>,
    },
    {
      title: "Tolls",
      dataIndex: "LTolls",
      key: "LTolls",
      render: (text) => text ? <Typography.Text>${Number(text).toFixed(2)}</Typography.Text> : "",
    },
    {
      title: "Miles",
      dataIndex: "LMiles",
      key: "LMiles",
      render: (text) => text ? <Typography.Text>{Number(text).toFixed(2)}</Typography.Text> : "",
    },
    {
      title: "Time",
      dataIndex: "LHours",
      key: "LHours",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record, index) => (
        <div className="icon-section">
          {index !== 0 && (
            <UpCircleFilled
              className="stop-up stop-icon"
              onClick={() => handleUpdateStops("up", index)}
            />
          )}
          {!(addedStops.length === 1 || index === addedStops.length - 1) && (
            <DownCircleFilled
              className="stop-down stop-icon"
              onClick={() => handleUpdateStops("down", index)}
            />
          )}
          <CloseCircleFilled
            className="stop-remove stop-icon"
            onClick={() => handleUpdateStops("remove", index)}
          />
        </div>
      ),
    },
  ];

  return (
    <Spin wrapperClassName="table-spin-content" spinning={isLoading}>
      <Table
        dataSource={addedStops}
        columns={columns}
        rowKey={(record, index) => index}
        pagination={false}
        summary={() => {
          const lastItem = addedStops[addedStops.length - 1];
          return lastItem?.TCostMile ? (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}><strong>Totals: ${Number(lastItem.TCostMile).toFixed(2)}</strong></Table.Summary.Cell>
              <Table.Summary.Cell index={2}><strong>${Number(lastItem.TTolls).toFixed(2)}</strong></Table.Summary.Cell>
              <Table.Summary.Cell index={3}><strong>{Number(lastItem.TMiles).toFixed(2)}</strong></Table.Summary.Cell>
              <Table.Summary.Cell index={4}><strong>{lastItem.THours}</strong></Table.Summary.Cell>
              <Table.Summary.Cell index={5}></Table.Summary.Cell>
            </Table.Summary.Row>
          ) : "";
        }}
      />
    </Spin>
  );
};

export default StopsTable;
